import { PMenuActionsModule } from './../../actions/pmenu.actions.module';
import { ActionsModule } from './../../actions/actions.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { proceduresComponent } from './procedures.component';
import { FormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { UserModule } from '../../user/user/user.module';
import { DossierHeaderModule } from '../components/dossierHeader.module';
import { TranslateModule } from '@ngx-translate/core';
import { procedureComponent } from './procedure.component';
import { TableModule } from 'primeng-lts/table';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { DirectivesModule } from '../../directives/directives.module';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { ProcedureMapComponent } from './procedureMap.component';
import { ButtonModule } from 'primeng-lts/button';
import { DropdownModule } from 'primeng-lts/dropdown';
import { MenuModule } from 'primeng-lts/menu';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';
import { RadioButtonModule } from 'primeng-lts/radiobutton';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TooltipModule } from 'primeng-lts/tooltip';
import { TreeModule } from 'primeng-lts/tree';
import { TreeTableModule } from 'primeng-lts/treetable';
import { StepsModule } from 'primeng-lts/steps';
import { TaskAssignmentModule } from '../../tasks/taskAssignment/taskAssignment.module';
import { ProcedureCircuitComponent } from './procedureCircuit.component';
import { SplitButtonModule } from 'primeng-lts/splitbutton';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { DialogModule } from 'primeng-lts/dialog';
import { InputSwitchModule } from 'primeng-lts/inputswitch';
import { BasicDocumentModule } from '../../documents/basicDocument/basicDocument.module';
import { SelectButtonModule } from 'primeng-lts/selectbutton';
import { DocumentViewerModule } from '../../documents/documentViewer/documentViewer.module';


@NgModule({
  declarations: [proceduresComponent, ProcedureCircuitComponent, procedureComponent, ProcedureMapComponent],
  imports: [
    CommonModule,
    FormsModule,

    DropdownModule,
    DossierHeaderModule,
    WaitLoadingModule,
    TableModule,
    FormPlycaModule,
    RouterModule,
    StepsModule,
    UserModule,
    PanelModule,
    TreeModule,
    TranslateModule,
    ButtonModule,
    TreeTableModule,
    DirectivesModule,
    SubHeaderModule,
    ScrollPanelModule,
    OverlayPanelModule,
    TooltipModule,
    MenuModule,
    RadioButtonModule,
    ActionsModule,
    TaskAssignmentModule,
    PMenuActionsModule,
    SplitButtonModule,
    MultiSelectModule,
    DialogModule,
    InputSwitchModule,
    BasicDocumentModule,
    SelectButtonModule,
    DocumentViewerModule
  ],
  exports: [ProcedureCircuitComponent, proceduresComponent]
})
export class ProceduresModule { }
